import React from 'react'
import classes from "./CallPageFooter.module.css";
import { Row, Col } from 'reactstrap';
import { formatDate } from "../../../../utils/FormatDate";
import defaultAvatar from '../../../../assets/img/avatar-blank.png';

const CallPageFooter = (props) => {


    const interval = React.useRef();
    const [showReaction, setShowReaction] = React.useState(false)
    const [currentTime, setCurrentTime] = React.useState(() => {
        return formatDate();
    });

    React.useEffect(() => {
        interval.current = setInterval(() => setCurrentTime(formatDate()), 1000);
        document.addEventListener('click', (e) => {
            if (!e.target.className.includes('toggle')) {
                setShowReaction(false)
            }
        })
        return () => {
            clearInterval(interval.current);
        };
    }, []);

    const screenUnShareScreenHandler = () => {
        if (props.isPresenting)
            props.stopScreenShareFunction()
        else
            props.screenShareFunction()
    }
    return (
        <Row className={classes.footerItem}>
            <Col className={classes.centerItem}>
                <div className={classes.headerItems} onClick={() => props.setOpenParticipants(1)}>
                    <h5 className={classes.meetInfoText}>{`${props.roomId}  |  ${currentTime}`}</h5>

                </div>

            </Col>
            <Col xs='12' md="6" lg="4" className={classes.centerItem}>
                <Row>
                    {/* <Col xs="4" md="2" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '5px 0px' }}>
                        <div className={classes.centerItemIconBlock}
                            onClick={props.showHideMeetingDetailsFunction}>

                            <i className={`fas fa-info ${classes.centerItemIcon}`} ></i>

                        </div>

                    </Col> */}
                    <Col xs="4" md="2" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '5px 0px' }}>
                        <div
                            className={`${classes.centerItemIconBlock} ${!props.isAudio ? classes.redBg : null}`}
                            onClick={() => props.toggleAudioFunction(!props.isAudio)}
                        >
                            <i className={`${props.isAudio ? 'fas fa-microphone' : `fas fa-microphone-slash`} ${classes.centerItemIcon}`}></i>
                        </div>

                    </Col>
                    <Col xs="4" md="2" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '5px 0px' }}>
                        <div className={`${classes.centerItemIconBlock} ${!props.isVideo ? classes.redBg : null}`}
                            onClick={() => props.toggleVideoFunction(!props.isVideo)}>
                            <i className={` ${props.isVideo ? 'fas fa-video' : `fas fa-video-slash`} ${classes.centerItemIcon}`} ></i>
                        </div>


                    </Col>
                    <Col xs="4" md="2" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '5px 0px' }}>
                        <div
                            style={{ position: 'absolute', cursor: 'default' }}>
                            <div className={'toggle ' + classes.centerItemIconBlock} onClick={() => setShowReaction(!showReaction)}>
                                <i className={`fa-solid fa-face-smile toggle ${classes.centerItemIcon}`} ></i>
                            </div>
                            {showReaction && <div className={'toggle ' + classes.reactionContainer}>
                                <div className='toggle' style={{ display: 'flex', paddingTop: '10px', justifyContent: 'center' }}>
                                    <div className='toggle' style={{ display: 'flex' }}>
                                        <h1 className={'toggle ' + classes.emojiText} onClick={() => props.sendEmoji('thumb')}>👍</h1>
                                        <h1 className={'toggle ' + classes.emojiText} onClick={() => props.sendEmoji('clap')}>👏 </h1>
                                        <h1 className={'toggle ' + classes.emojiText} onClick={() => props.sendEmoji('laugh')}>😆</h1>
                                        <h1 className={'toggle ' + classes.emojiText} onClick={() => props.sendEmoji('heart')}>❤️ </h1>
                                        <h1 className={'toggle ' + classes.emojiText} onClick={() => props.sendEmoji('open_mouth')}>😮</h1>
                                        <h1 className={'toggle ' + classes.emojiText} onClick={() => props.sendEmoji('party')}>🎉</h1>
                                    </div>
                                </div>
                                <div className={'toggle ' + classes.raiseHandContainer} onClick={() => props.sendEmoji('raise_hand')}>
                                    <h5 className={'toggle ' + classes.raiseHandText}>
                                        ✋ Raise hand
                                    </h5>
                                </div>
                            </div>}
                        </div>

                    </Col>
                    <Col xs="4" md="2" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '5px 0px' }}>

                        <div className={`${classes.centerItemIconBlock} ${props.isPresenting ? classes.activeBgIcon : null}`}
                            onClick={screenUnShareScreenHandler}>

                            <i className={` ${!props.isPresenting ? 'fas fa-desktop' : `fas fa-desktop ${classes.activeShare}`} ${classes.centerItemIcon}`} ></i>

                        </div>
                    </Col>
                    <Col xs="4" md="2" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '5px 0px' }}>
                        <div className={classes.centerItemIconBlockPhone} onClick={props.disconnectCallFunction}>
                            <i className={`fas fa-phone ${classes.centerItemIcon}`} ></i>
                        </div>

                    </Col>
                    <Col xs="4" md="2" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '5px 0px' }}>

                        <div className={`${classes.centerItemIconBlock}`}
                            onClick={props.toggleSettingsFunction}>
                            <i className={`fas fa-ellipsis-v ${classes.centerItemIcon}`} ></i>
                        </div>
                    </Col>
                </Row>
            </Col>
            <Col className={classes.centerItem}>
                <div className={classes.headerItems} style={{ position: 'relative' }} onClick={() => props.setOpenParticipants(1)}>
                    {props.participants.length > 0 && <div className={classes.badgeContainer}>
                        <h5 className={classes.badgeText}>{props.participants.length}</h5>
                    </div>}
                    <i className={`fas fa-user-friends ${classes.icon} ${props.isOpenMessenger === 1 ? classes.activeIcon : ''}`}></i>
                </div>
                <div
                    className={`${classes.headerItems} ${classes.iconBlock}`}
                    onClick={() => {
                        props.setIsOpenMessenger(2);
                        props.setNotification(null);
                    }}
                >
                    <i className={`fas fa-comment-alt ${classes.icon} ${props.isOpenMessenger === 2 ? classes.activeIcon : ''}`}></i>

                    {!props.isOpenMessenger && props.notification &&
                        <span className={classes.alertCircleIcon}></span>
                    }
                </div>
                <div className={classes.headerItems}>
                    <img src={props.userImage || defaultAvatar} alt="participant" className={classes.userImage} />
                </div>
            </Col>
        </Row>
    );
};


export default CallPageFooter;
